import { useDispatch } from 'react-redux';
import { IonItem, IonSelect, IonSelectOption } from '@ionic/react';

import UnitLabels from 'config/unit-labels';
import ProjectSettingsActions from 'actions/ProjectSettingsActions';

export default function LoadUnitSelector({settings}) {
  const dispatch = useDispatch();
  const {unitType:selected} = settings;
  const changeUnits = (e) => dispatch(ProjectSettingsActions.setUnits(e.detail.value));

  return (
    <IonItem>
      <IonSelect label="Primary units" onIonChange={changeUnits} value={selected}>
        {UnitLabels.map(({label, value}) => (
          <IonSelectOption key={value} value={value}>{label}</IonSelectOption>
        ))}
      </IonSelect>
    </IonItem>
  );
}
